import { render } from "./ToggleGoogle2faModal.vue?vue&type=template&id=65752bf8"
import script from "./ToggleGoogle2faModal.vue?vue&type=script&lang=js"
export * from "./ToggleGoogle2faModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/ToggleGoogle2faModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65752bf8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65752bf8', __exports__)) {
    api.reload('65752bf8', __exports__)
  }
  
  module.hot.accept("./ToggleGoogle2faModal.vue?vue&type=template&id=65752bf8", () => {
    api.rerender('65752bf8', render)
  })

}


export default __exports__